import { render } from "./FriendLink.vue?vue&type=template&id=50d6f24c&scoped=true"
import script from "./FriendLink.vue?vue&type=script&lang=js"
export * from "./FriendLink.vue?vue&type=script&lang=js"

import "./FriendLink.vue?vue&type=style&index=0&id=50d6f24c&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d6f24c"]])

export default __exports__